import ProductCreditBadge from './ProductCreditBadge'

export default ProductCreditBadge
